export const RankWorth = [
  10, 25, 100, 250, 400, 550, 700, 850, 1000, 1150, 1300, 1450, 1600, 1750,
  1900, 2050, 2200, 2350, 2500, 2650, 2800, 2950, 3100, 3250, 3400, 3550, 3700,
  3850, 4000, 4150,
];

export const RoleWorth = {
  Don: 650,
  Consigliere: 400,
  Capodecina: 300,
  Capo: 100,
  "Regime member": 50,
  "Family member": 25,
  "Non member": 0,
};

export const BulletWorthUnit = 1000 / 2;

export const CashWorth = [
  { min: 0, max: 100000, worth: 5 },
  { min: 100000, max: 500000, worth: 15 },
  { min: 500000, max: 5000000, worth: 35 },
  { min: 500000, max: 10000000, worth: 50 },
  { min: 10000000, max: 25000000, worth: 75 },
  { min: 25000000, max: 100000000, worth: 100 },
  { min: 100000000, max: 100000000000, worth: 125 },
];

export const PlusPlayerWorth = 50;
export const MafiaWorthUnit = 3000;
export const CityWorth = 200;
export const CreditWorthUnit = 100;
